import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../Components/Firebase";
import Loading from "../../Components/Loading";

function CheckUser() {
  const { UID } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const userRef = doc(db, "Users", UID);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          const role = userData.Role;

          if (role === "Admin") {
            navigate(`/AdminHome/${UID}`);
          } else if (role === "Sapakim") {
            navigate(`/SapakimHome/${UID}`);
          } else {
            alert("המשתמש לא מורשה או תפקיד לא מזוהה.");
          }
        } else {
          alert("משתמש לא נמצא במסד הנתונים.");
        }
      } catch (error) {
        console.error("שגיאה בבדיקת המשתמש:", error);
        alert("אירעה שגיאה בעת בדיקת המשתמש.");
      }
    };

    fetchUserRole();
  }, [UID, navigate]);

  return <Loading />;
}

export default CheckUser;
